import React from 'react';
export const Purse: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16.605"
      fill="currentColor"
      {...props}
    >
      <g fill="currentColor">
        <path
          data-name="Path 21798"
          d="M17.001 14.55c-.583 1.037-1.577 1.48-3.325 1.48-.694 0-1.431-.065-2.211-.135-.809-.072-1.646-.146-2.465-.146s-1.656.074-2.465.146c-.78.069-1.517.135-2.211.135-1.748 0-2.742-.443-3.325-1.48-1.029-1.832.063-4.267.786-5.878a9.723 9.723 0 00.5-1.233 5.673 5.673 0 00.149-.952c.085-.888.132-1.377 1.516-1.377h10.108c1.384 0 1.431.489 1.516 1.377a5.673 5.673 0 00.149.952 9.736 9.736 0 00.5 1.233c.723 1.611 1.815 4.045.786 5.877zm-.262-6.113a9.562 9.562 0 01-.467-1.147 5.164 5.164 0 01-.131-.857c-.085-.889-.182-1.9-2.088-1.9H3.945c-1.906 0-2 1.008-2.088 1.9a5.164 5.164 0 01-.131.857 9.531 9.531 0 01-.467 1.147c-.77 1.716-1.934 4.31-.763 6.395.883 1.572 2.508 1.773 3.826 1.773.72 0 1.469-.067 2.262-.137s1.621-.144 2.414-.144 1.618.073 2.415.144 1.542.137 2.262.137c1.318 0 2.943-.2 3.826-1.773 1.171-2.085.007-4.678-.763-6.394z"
        />
        <path
          data-name="Path 21800"
          d="M.778 6.659a.287.287 0 00.354-.2 6.231 6.231 0 00.172-1.072c.1-1.027.157-1.593 1.811-1.593h11.769c1.655 0 1.711.566 1.812 1.593a6.231 6.231 0 00.172 1.072.288.288 0 00.554-.154 5.7 5.7 0 01-.154-.975c-.1-1.038-.208-2.112-2.384-2.112H3.117C.941 3.218.836 4.292.733 5.33a5.7 5.7 0 01-.154.975.288.288 0 00.2.354z"
        />
        <path
          data-name="Path 21801"
          d="M7.534.575a.69.69 0 11-.69.69.691.691 0 01.69-.69zm0 1.955a1.265 1.265 0 10-1.265-1.265A1.266 1.266 0 007.534 2.53z"
        />
        <path
          data-name="Path 21802"
          d="M10.466.575a.69.69 0 11-.69.69.691.691 0 01.69-.69zm0 1.955a1.265 1.265 0 10-1.265-1.265 1.266 1.266 0 001.265 1.265z"
        />
      </g>
    </svg>
  );
};
